/**
 * 视频通话接听消息处理
 */

import { useVideoCallStore } from '@/stores/videoCall'
import { closeFloatingMatchStatus } from '@/components/FloatingMatchStatus'
import { showToast } from 'vant'
import router from '@/router'
import { t } from '@/locales'
import { track } from '@/utils/tracker'
import agoraManager from '@/managers/AgoraRTCManager'

import { formatJoinMessage } from './utils'

/**
 * 处理视频通话接听消息（LOVE_ROOM_JOIN）
 *
 * 场景：
 * - 随机匹配中，后端通过IM推送JOIN消息，加入频道并跳转
 *
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export async function handleVideoCallJoin(event) {
  console.log('[handleVideoCallJoin] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  const message = messages[0] || {}
  const videoCallStore = useVideoCallStore()

  // 只处理随机匹配中的JOIN消息
  if (!videoCallStore.isMatching) {
    return
  }

  const { msg_content } = message
  const { love_room } = msg_content
  const { room_id, member, free_duration, live_id, channel_id } = love_room

  if (!room_id) {
    showToast(t('videoCall.error.invalidCallInfo'))
    return
  }

  const { rtc_server, member_id } = member || {}
  if (!rtc_server) {
    showToast(t('videoCall.error.noRtcConfig'))
    return
  }

  try {
    // 更新状态并保存房间信息
    videoCallStore.startCall(love_room)

    // 1. 加入Agora频道
    await agoraManager.joinChannel({
      channelId: channel_id,
      token: rtc_server.access_token,
      uid: member_id,
    })
    console.log('[handleVideoCallJoin] Joined Agora channel')

    // 2. 发布本地轨道
    await agoraManager.publishTracks()
    console.log('[handleVideoCallJoin] Published local tracks')

    // 3. 更新状态为已连接
    videoCallStore.connectCall()

    // 4. 上报埋点
    const isTrial = free_duration > 0
    track('call_1v1_status_change_video_room', {
      live_id,
      status: 'connected',
      is_trial: isTrial,
    })

    // 5. 关闭匹配浮窗
    closeFloatingMatchStatus()

    // 6. 跳转到视频页面
    router.push({
      name: 'video',
      params: { roomId: room_id },
      state: formatJoinMessage(message),
    })
  } catch (error) {
    showToast(error.message || t('videoCall.error.joinFailed'))
    videoCallStore.resetCall()
    await agoraManager.destroy()
  }
}
